module.exports = __webpack_public_path__ + "static/media/pat.cdb0a6ff.png";